"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _lodash = _interopRequireDefault(require("lodash.omit")),
    _uiKit = require("@devsta/ui-kit"),
    _getValueFromGenericInput = require("@devsta/get-value-from-generic-input"),
    _reactCopyToClipboard = require("react-copy-to-clipboard"),
    _reactAnimateHeight = _interopRequireDefault(require("react-animate-height")),
    _SharingSettings = _interopRequireDefault(require("./SharingSettings")),
    _AccessPermissions = _interopRequireDefault(require("./AccessPermissions")),
    _utils = require("../../../utils"),
    _getSharingUrl = _interopRequireDefault(require("../utils/getSharingUrl"));

require("../styles/_share-modal.scss");

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var ShareModal = function (a) {
  function b() {
    var a;
    return (0, _classCallCheck2["default"])(this, b), a = c.call(this), a.onCopySuccess = function () {
      a.setState({
        copied: !0
      }, function () {
        setTimeout(function () {
          a.setState({
            copied: !1
          });
        }, 2e3);
      });
    }, a.onUpdateShareSetting = function (b) {
      var c = b.shareSetting;
      return function () {
        var b = a.props,
            d = b.onChangeLinkShareSettings,
            e = b.organisationId;
        d((0, _utils.convertToSharingSettings)(c, e));
      };
    }, a.changeAccessPermission = function (b) {
      var c = a.props,
          d = c.onChangeLinkShareSettings,
          e = c.roles,
          f = e.find(function (a) {
        var c = a.description;
        return c === (0, _getValueFromGenericInput.getStringValueFromGenericInput)(b);
      });
      d({
        role: (0, _lodash["default"])(f, ["description", "__typename"])
      });
    }, a.handleOnClose = function () {
      var b = a.props.onClose;
      b();
    }, a.state = {
      copied: !1
    }, a;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "render",
    value: function render() {
      var a = this.props,
          b = a.resourceName,
          c = a.visible,
          d = a.onSaveLinkSharingSettings,
          e = a.linkSharingSettings,
          f = a.roles,
          g = a.shareUrl,
          h = this.state.copied,
          i = e || {},
          j = i["public"],
          k = i.organisation,
          l = i.canSearch,
          m = i.role,
          n = (0, _getSharingUrl["default"])({
        shareUrl: g,
        location: window.location,
        isPublic: j
      });
      return _react["default"].createElement("div", {
        className: "share-modal-container"
      }, _react["default"].createElement(_uiKit.FormModal, {
        visible: c,
        onClose: this.handleOnClose,
        className: "share-modal share-modal-advanced",
        title: "Share ".concat(b),
        subtitle: "Share your ".concat(b, " with others"),
        saveText: "Save Changes",
        onSave: d
      }, _react["default"].createElement("div", {
        className: "share-modal__body"
      }, _react["default"].createElement("div", null, _react["default"].createElement("div", {
        className: "share-modal__body__copy"
      }, _react["default"].createElement(_uiKit.Input, {
        defaultValue: n,
        key: n,
        className: "share-modal__url",
        disabled: !0
      }), _react["default"].createElement(_reactCopyToClipboard.CopyToClipboard, {
        text: n,
        onCopy: this.onCopySuccess
      }, _react["default"].createElement("div", {
        className: "share-modal__body__copy__action"
      }, _react["default"].createElement(_uiKit.Button, {
        type: "TERTIARY",
        prefix: h ? "success" : "duplicate",
        disabled: h,
        tooltipId: "copy-link-btn",
        tooltipLabel: "Copy link"
      })))), _react["default"].createElement("hr", {
        className: "share-modal__horizontal-line"
      }), _react["default"].createElement(_reactAnimateHeight["default"], {
        duration: 450,
        height: 485
      }, _react["default"].createElement("div", {
        className: "share-modal__advanced-settings"
      }, _react["default"].createElement(_SharingSettings["default"], {
        shareSetting: (0, _utils.fetchSharingType)({
          isPublic: j,
          organisation: k,
          canSearch: l
        }),
        onUpdateShareSetting: this.onUpdateShareSetting
      }), _react["default"].createElement(_AccessPermissions["default"], {
        onChange: this.changeAccessPermission,
        defaultValue: (0, _utils.getSelectedRole)(m, f),
        options: (0, _utils.getRoles)(f)
      })))))));
    }
  }]), b;
}(_react.Component);

exports["default"] = ShareModal;